import APIUrl from "../../APIUrl";
import axios from "axios";
import { getAdmin } from "../admin/admin";

export const LOGOUT = "LOGOUT";
export const GET_URL = "GET_URL";

function getLogoutAction() {
  return { type: LOGOUT };
}

export const login = function (
  email,
  password,
  successCallback,
  failureCallback,
) {
  return function (dispatch) {
    return axios
      .post(APIUrl.login, { email: email, password: password })
      .then(function (response) {
        // Add jwt token to headers
        axios.defaults.headers.common["jwtToken"] = response.headers.jwttoken;
        APIUrl.jwtToken = response.headers.jwttoken;

        // Add JWT token to storage
        sessionStorage.setItem("jwt", response.headers.jwttoken);
        dispatch(getAdmin());

        return successCallback(response.data.user);
      })
      .catch(function (err) {
        console.log(err);
        return failureCallback();
      });
  };
};

export const logout = function (successCallback) {
  return function (dispatch) {
    // Delete tokens
    axios.defaults.headers.common["jwtToken"] = null;

    delete axios.defaults.headers.jwtToken;
    delete axios.defaults.headers.common["jwtToken"];
    delete APIUrl.jwtToken;

    // Clear session storage
    sessionStorage.clear();

    dispatch(getLogoutAction());
    successCallback();
  };
};
